import errors from './errors/index.js';
import translation from './translation/index.js';
const de = {
    translation,
    errors,
};
export default Object.freeze(de);
